export default {
  UPDATE_RATINGS_SCALE(state, value) {
    state.ratingScale = value;
  },
  UPDATE_RATING_DETAILS(state, value) {
    state.ratingDetails = value;
  },
};
